export { AvatarGroupProvider } from '@fluentui/react-avatar';
